/**
 * The "worth" of a bundle: the sum of the prices of the games in its tiers,
 * each floored to a whole minor unit. Legacy cartcalc.js tierPricing().
 *
 * @param   {Object[]} tiers        The bundle tiers of a basket item, each with `games`.
 * @param   {string}   currencyCode ISO 4217
 * @returns {number}                Minor units. 0 when there are no priced games.
 */
export default (tiers, currencyCode) => (tiers ?? [])
  .flatMap(tier => tier.games ?? [])
  .reduce((total, game) => total + Math.floor(game?.price?.[currencyCode] ?? 0), 0);
